import { Button, Empty, Result, Skeleton, Space, Typography, message } from 'antd';
import type { ReactNode } from 'react';
import { normalizeTextValue, resolveTextDisplay } from './presentation';

export function PageLoadingState({ rows = 6 }: { rows?: number }) {
  return <Skeleton active paragraph={{ rows }} />;
}

export function EmptyState({ description = '暂无数据' }: { description?: ReactNode }) {
  return <Empty description={description} />;
}

export function ErrorState({
  title = '加载失败',
  detail,
  onRetry,
}: {
  title?: string;
  detail?: ReactNode;
  onRetry?: () => void;
}) {
  return (
    <Result
      status="error"
      title={title}
      subTitle={detail}
      extra={onRetry ? <Button onClick={onRetry}>重新加载</Button> : undefined}
    />
  );
}

export function CopyText({ value, children }: { value?: string | number | null; children?: ReactNode }) {
  const text = normalizeTextValue(value);
  return (
    <Space size={4}>
      <Typography.Text>{children ?? resolveTextDisplay(value)}</Typography.Text>
      {text ? (
        <Typography.Link
          onClick={async () => {
            await navigator.clipboard.writeText(text);
            message.success('已复制');
          }}
        >
          复制
        </Typography.Link>
      ) : null}
    </Space>
  );
}
